//
// locales/vanilla/fi.js
// automatically generated by generateLocalePacks.js
//

import messages from '../../../app/javascript/mastodon/locales/fi.json';
import localeData from 'react-intl/locale-data/fi.js';
import { setLocale } from 'locales';

setLocale({
  localeData,
  messages,
});
